import { deadlineMs, msToSec, nowSec } from "@breakout/shared/utils/time"

/**
 * Convert a Date to a local datetime input string (for datetime-local inputs).
 */
export function toLocalDatetimeInput(date: Date): string {
	const pad = (value: number) => value.toString().padStart(2, "0")
	return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`
}

/**
 * Convert a datetime-local input string to epoch seconds.
 */
export function toEpochSeconds(value: string): number {
	if (!value) {
		return 0
	}
	const millis = new Date(value).getTime()
	return Number.isNaN(millis) ? 0 : msToSec(millis)
}

/**
 * Get default form times (open in 2 minutes, cutoff in 7 days).
 */
export function getDefaultFormTimes() {
	return {
		openTimeSec: toLocalDatetimeInput(new Date(deadlineMs(120))),
		cutoffTimeSec: toLocalDatetimeInput(new Date(deadlineMs(604800))),
	}
}

const MIN_START_TIME_BUFFER_SECONDS = 60 // 1 minute buffer

/**
 * Validate market open and cutoff times
 */
export function validateMarketTimes(
	openTimeSec: number,
	cutoffTimeSec: number,
): { valid: true } | { valid: false; error: string } {
	const now = nowSec()
	const minOpenTime = now + MIN_START_TIME_BUFFER_SECONDS

	if (openTimeSec < minOpenTime) {
		return {
			valid: false,
			error: `Open time must be at least ${MIN_START_TIME_BUFFER_SECONDS} seconds in the future`,
		}
	}

	if (cutoffTimeSec <= openTimeSec) {
		return {
			valid: false,
			error: "Cutoff time must be after open time",
		}
	}

	return { valid: true }
}
